// extracted by mini-css-extract-plugin
export default {"noBackground":"dha-z","qnaContainer":"eha-z","qna":"fha-z","question":"gha-z","modal":"hha-z"};